<script setup>
import { AcceptOfferDialogProgrammatic } from './AcceptOfferDialog'
import { CancelOfferDialogProgrammatic } from './CancelOfferDialog'
import { currency } from '~/ui/vue/filters'

const { updateOfferState } = inject('actions')

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const showActivityMenu = ref(false)

const hasOffer = computed(() => Boolean(props.params?.data.guaranteeOffer?.state === 'OfferAccepted'))
const offerData = computed(() => props.params?.data.guaranteeOffer)
const date = computed(() => offerData.value?.created ? formatDate(offerData.value.created) : ' - ')
const price = computed(() => offerData.value?.price ? currency(offerData.value.price) : ' - ')
const user = computed(() => offerData.value?.user?.profile?.name || ' - ')

const handleAcceptOffer = async () => {
  const data = await AcceptOfferDialogProgrammatic.open({
    data: props.params.data,
    action: updateOfferState
  })

  if (data) {
    props.params.node.setData({
      ...props.params.node.data,
      guaranteeOffer: data
    })
  }
}

const handleCancelOffer = async () => {
  const data = await CancelOfferDialogProgrammatic.open({
    data: props.params.data,
    action: updateOfferState
  })

  if (data) {
    props.params.node.setData({
      ...props.params.node.data,
      guaranteeOffer: null
    })
  }
}

const formatDate = dateString => {
  const date = new Date(dateString)
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  return date.toLocaleDateString('en-US', options)
}
</script>

<template>
  <VBtn
    v-if="!hasOffer"
    color="primary"
    width="100%"
    class="rounded-pill"
    variant="flat"
    size="small"
    @click="handleAcceptOffer"
  >
    Accept Offer
  </VBtn>
  <div
    v-else
    class="pt-1 d-flex align-center justify-space-between"
  >
    <VBtn
      class="rounded-pill"
      variant="text"
      color="primary"
      size="small"
      @click="handleCancelOffer"
    >
      Cancel Offer
    </VBtn>

    <VMenu
      v-model="showActivityMenu"
      :open-on-hover="true"
      :close-on-content-click="false"
      location="top"
    >
      <template #activator="{ props: activityProps }">
        <VChip
          v-bind="activityProps"
          class="rounded-pill"
          variant="tonal"
          color="primary"
          size="small"
          data-testid="activity"
          prepend-icon="$history"
        >
          Activity
        </VChip>
      </template>

      <VCard
        min-width="100"
        class="pa-4 rounded-lg"
      >
        <VCardText class="pa-0 text-body-2 text-medium-emphasis">
          <div class="font-weight-medium mb-1">
            Offer Accepted:
          </div>
          {{ price }}<br>
          {{ date }}<br>
          {{ user }}<br>
        </VCardText>
      </VCard>
    </VMenu>
  </div>
</template>
